import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { normalizeSlackChannel } from "@/common/utils/slack";
import { useFeatureData } from "@/feature/data/useFeatureData";

export default function useFeatureIntegrations(featureId: string) {
  const { org, app } = useEnvironment();

  const { data: feature, isLoading } = useFeatureData(featureId);

  const appSlackChannel = normalizeSlackChannel(
    app.integrations?.slack?.channel ?? undefined,
  );

  const slackChannel = org.integrations.slack
    ? feature?.integrations.slack.slackChannel
      ? feature.integrations.slack.slackChannel
      : appSlackChannel
    : undefined;

  const linearTrackingEntity = org.integrations.linear
    ? feature?.integrations.linear?.trackingEntity
    : undefined;

  return {
    isLoading,
    linear:
      !isLoading && !!feature?.integrations.linear && !!linearTrackingEntity
        ? {
            ...feature.integrations.linear,
            trackingEntity: linearTrackingEntity,
          }
        : undefined,
    slack:
      !isLoading && !!feature?.integrations.slack && !!slackChannel
        ? {
            ...feature.integrations.slack,
            slackChannel,
          }
        : undefined,
  };
}
